import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

interface SendFeedbackDTO {
    videoId: string;
    message: string;
}

type FeedbackResponse = ApiError & SendFeedbackDTO

export const SendFeedback = (data: SendFeedbackDTO): Promise<FeedbackResponse> => {
    return axios.post("/feedback-video/create", data)
        .then(response => response.data as FeedbackResponse);
};